import script from "./mainSection.vue?vue&type=script&setup=true&lang=js"
export * from "./mainSection.vue?vue&type=script&setup=true&lang=js"

import "./mainSection.vue?vue&type=style&index=0&id=4cdcbe56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cdcbe56"]])

export default __exports__